import type { ButtonHTMLAttributes, HTMLAttributes } from 'react'

import styles from './Chip.module.css'

export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  plain?: boolean
}

export function Chip({ plain = false, className = '', ...props }: ChipProps) {
  return <span className={`${styles.chip} ${plain ? styles.plain : ''} ${className}`} {...props} />
}

export interface ChipSelectableProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean
}

export function ChipSelectable({ selected = false, className = '', ...props }: ChipSelectableProps) {
  return <button type="button" className={`${styles.selectable} ${selected ? styles.selected : ''} ${className}`} {...props} />
}
